module.exports = __webpack_public_path__ + "static/media/thehighcross.52cd0bb1.jpg";